<!-- 公共的logo，crawl选择-->
<template>
  <div class="CategorySelect">
    <div class="SelectVideo" :title="SelectValue">
      <el-select
        v-model="pitchOnFile"
        :disabled="disabled"
        :popper-append-to-body="AppendBody"
        :placeholder=" placeholder ? $t(`lang.${placeholder}`) : ''"
        @change="fileSelectChange"
        :loading="FirstLoading"
        >
        <el-option
          v-for="(item,index) in FileSelectList"
          :key="index"
          :label="item"
          :value="item">
          <span class="videoLeft" style="float: left;width: 100%;overflow: hidden;text-overflow: ellipsis;" :title="item">{{ item }}</span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    //   选择的参数
    SelectValue: {
      type: String,
      default: ''
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否将弹出框插入至 body 元素,在弹出框的定位出现问题时，可将该属性设置为 false
    AppendBody: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      //   选中的
      pitchOnFile: '',
      // 加载
      FirstLoading: false,
      // 选项列表
      FileSelectList: []
    }
  },
  created () {
    this.pitchOnFile = this.SelectValue
    this.FirstGetData()
  },
  mounted () {
  },
  watch: {
    // 监听外部传的值是否变化
    SelectValue (data) {
      this.pitchOnFile = data
    }
  },
  methods: {
    // 第一次获取数据
    FirstGetData () {
      this.FirstLoading = true
      const ProgramId = this.$BehaviorSyns.getProgramId()
      if (!ProgramId) return
      this.axios.post(Outil.getUrl('/advance-setting/epg'), {
        programId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const FileSelectList = res.data.result.category ? res.data.result.category.split(',') : []
          this.FileSelectList = FileSelectList
          this.FirstLoading = false
          if (!this.SelectValue) {
            this.$emit('fileSelectChange', res.data.result.defaultCategory)
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 文件选中变化
    fileSelectChange () {
      this.$emit('fileSelectChange', this.pitchOnFile)
    }
  }
}
</script>
<style scoped lang="less">
.CategorySelect{
  ::v-deep .SelectVideo{
    .el-select-dropdown{
      .el-scrollbar__wrap{
        .el-scrollbar__view{
          width: 100%;
          text-align: left;
        }
      }
    }
  }
}
</style>
